import { Uuid } from "@/domains/global/identifiers";
import { api } from "@/modules/api";
import { useQuery } from "@tanstack/react-query";

import { FC } from "react";
import { useParams } from "react-router";

export const SyncScopesViewPage: FC = () => {
  const { syncScopeId } = useParams<{ syncScopeId: Uuid }>();

  if (!syncScopeId) {
    return <div>Invalid ID</div>;
  }

  const result = useQuery({
    queryKey: ["sync-scope-by-id", syncScopeId],
    queryFn: () =>
      api.get("/internal/v1/sync-scopes/{sync_scope_id}", {
        params: {
          path: {
            sync_scope_id: syncScopeId,
          },
        },
      }),
  });

  return (
    <div>
      <h1>View SyncScope</h1>
      <pre>{JSON.stringify(result.data, null, 2)}</pre>
    </div>
  );
};
